import React from 'react';

function Tajikistan(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123982)">
        <mask
          id="mask0_800_123982"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123982)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V8H36V0H0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16V24H36V16H0Z"
            fill="#409100"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0227 8.6298L17.3576 9.04752L17.5922 8.34753L16.9465 7.9057L17.7566 7.8908L18.0227 7.20001L18.2887 7.8908L19.0988 7.9057L18.4531 8.34753L18.6878 9.04752L18.0227 8.6298ZM15.2133 9.24259L14.5482 9.66031L14.7829 8.96032L14.1372 8.51849L14.9473 8.50359L15.2133 7.81281L15.4794 8.50359L16.2895 8.51849L15.6438 8.96032L15.8784 9.66031L15.2133 9.24259ZM12.3633 11.4986L13.0284 11.0808L13.6935 11.4986L13.4589 10.7986L14.1045 10.3567L13.2945 10.3418L13.0284 9.65106L12.7624 10.3418L11.9523 10.3567L12.598 10.7986L12.3633 11.4986ZM12.3261 13.4638L11.661 13.8816L11.8957 13.1816L11.25 12.7397L12.0601 12.7248L12.3261 12.0341L12.5922 12.7248L13.4022 12.7397L12.7566 13.1816L12.9912 13.8816L12.3261 13.4638ZM22.976 13.8816L23.6411 13.4638L24.3062 13.8816L24.0715 13.1816L24.7172 12.7397L23.9071 12.7248L23.6411 12.0341L23.375 12.7248L22.565 12.7397L23.2106 13.1816L22.976 13.8816ZM22.7828 11.0808L22.1177 11.4986L22.3523 10.7986L21.7066 10.3567L22.5167 10.3418L22.7828 9.65106L23.0488 10.3418L23.8589 10.3567L23.2132 10.7986L23.4479 11.4986L22.7828 11.0808ZM19.9655 9.66031L20.6306 9.24259L21.2956 9.66031L21.061 8.96032L21.7067 8.51849L20.8966 8.50359L20.6306 7.81281L20.3645 8.50359L19.5544 8.51849L20.2001 8.96032L19.9655 9.66031ZM14.2508 16.7546L14.0434 16.0982C15.1909 15.8222 16.5084 15.6849 17.996 15.6849C19.4836 15.6849 20.8011 15.8222 21.9486 16.0982L21.7412 16.7546C20.6656 16.4959 19.4171 16.3658 17.996 16.3658C16.5749 16.3658 15.3264 16.4959 14.2508 16.7546ZM15.6719 15.702C15.2141 15.7711 14.8396 15.3777 14.8396 15.3777L15.2939 15.2109C15.2795 14.931 15.4694 14.7574 15.4694 14.7574C15.6231 14.8203 15.8327 15.164 15.8327 15.164H16.2445C16.2445 15.164 16.1298 15.6329 15.6719 15.702ZM21.0826 15.4458C21.0826 15.4458 20.7081 15.8392 20.2503 15.7701C19.7924 15.701 19.6777 15.2322 19.6777 15.2322H20.0895C20.0895 15.2322 20.2991 14.8885 20.4528 14.8256C20.4528 14.8256 20.6427 14.9991 20.6283 15.279L21.0826 15.4458ZM17.9385 15.5774C17.4743 15.5892 17.1651 15.1533 17.1651 15.1533L17.6411 15.0443C17.6707 14.7653 17.8859 14.617 17.8859 14.617C18.0282 14.6983 18.182 15.0646 18.182 15.0646L18.5898 15.1155C18.5898 15.1155 18.4028 15.5656 17.9385 15.5774Z"
            fill="#FFBB00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.9534 13.6987C17.9534 13.6987 17.4258 14.772 16.5948 14.855C15.7639 14.938 15.3418 14.2446 15.3418 14.2446C15.3418 14.2446 15.2874 14.9657 14.3005 15.2436C13.3136 15.5216 12.7939 14.411 12.7939 14.411C12.7939 14.411 13.3077 14.8195 14.1046 14.6415C14.9015 14.4635 15.216 13.8061 15.216 13.8061C15.216 13.8061 15.8058 14.4915 16.5948 14.1488C17.3839 13.8061 17.8204 13.3873 17.8204 12.9854V11.7836C17.8204 11.7836 17.6169 11.4719 17.2637 11.4719C16.9106 11.4719 16.812 11.6929 16.812 11.6929C16.812 11.6929 16.6742 10.4425 17.9443 10.3653L17.9443 10.3622C17.9561 10.3625 17.9678 10.363 17.9794 10.3634C17.991 10.363 18.0027 10.3625 18.0145 10.3622L18.0144 10.3653C19.2846 10.4425 19.1467 11.6929 19.1467 11.6929C19.1467 11.6929 19.0482 11.4719 18.695 11.4719C18.3419 11.4719 18.1383 11.7836 18.1383 11.7836V12.9854C18.1383 13.3873 18.5748 13.8061 19.3639 14.1488C20.153 14.4915 20.7427 13.8061 20.7427 13.8061C20.7427 13.8061 21.0573 14.4635 21.8541 14.6415C22.651 14.8195 23.1648 14.411 23.1648 14.411C23.1648 14.411 22.6451 15.5216 21.6582 15.2436C20.6714 14.9657 20.6169 14.2446 20.6169 14.2446C20.6169 14.2446 20.1949 14.938 19.3639 14.855C18.5329 14.772 18.0053 13.6987 18.0053 13.6987L17.9794 12.2813L17.9534 13.6987ZM17.9417 10.7019C17.3558 10.7019 17.2371 11.1428 17.2371 11.1428C17.7531 11.1428 17.9417 11.3427 17.9417 11.3427C17.9417 11.3427 18.3237 11.1428 18.7083 11.1428C18.7083 11.1428 18.5277 10.7019 17.9417 10.7019Z"
            fill="#FFBB00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123982">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Tajikistan;
